import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";

import { ROUTES } from "@/router/router.config";
import { beforeEachGuard } from "@/router/router.utils";

Vue.use(VueRouter);

const routes = [
  {
    path: ROUTES.home.path,
    name: ROUTES.home.name,
    component: Home,
    meta: { requireAuth: true }
  },
  {
    path: ROUTES.login.path,
    name: ROUTES.login.name,
    component: () => import("@/views/Login.vue")
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(beforeEachGuard);

export default router;
